 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"AccountPage":"AccountPage","CatalogPage~OrdersPage~ProductPage~ShoppingCartPage":"CatalogPage~OrdersPage~ProductPage~ShoppingCartPage","CatalogPage~ProductPage~ShoppingCartPage":"CatalogPage~ProductPage~ShoppingCartPage","CatalogPage":"CatalogPage","IndexPage~ShoppingCartPage":"IndexPage~ShoppingCartPage","ShoppingCartPage":"ShoppingCartPage","ProductPage":"ProductPage","OrdersPage":"OrdersPage","ContactsPage":"ContactsPage","IndexPage":"IndexPage","PricesPage":"PricesPage"}[chunkId]||chunkId) + "." + {"AccountPage":"2b32dba4","CatalogPage~OrdersPage~ProductPage~ShoppingCartPage":"26122e48","CatalogPage~ProductPage~ShoppingCartPage":"a651dc3b","CatalogPage":"2cbcb374","IndexPage~ShoppingCartPage":"b6f26bf4","ShoppingCartPage":"6b523980","ProductPage":"78267fc4","OrdersPage":"a46e7b41","ContactsPage":"f8a3eca7","chunk-fe4a6dc6":"bcc7e1bf","IndexPage":"1da97554","PricesPage":"ce8bf0fe","chunk-2d0a34e8":"756512c9","chunk-2d0a47fc":"f79e2351","chunk-2d0a4b23":"9194f463","chunk-2d0b1db6":"74aa405a","chunk-2d0ba187":"df208738","chunk-2d0bdcab":"94f4404a","chunk-2d0be158":"8eb7ceb1","chunk-2d0c02b3":"dd41a525","chunk-2d0c06e4":"c2099173","chunk-2d0c19d7":"8fd6d7ea","chunk-2d0c5777":"4cddc215","chunk-2d0c7306":"ba9b2b4a","chunk-2d0c8c23":"a2c5706b","chunk-2d0ccb7b":"78366d98","chunk-2d0cfe76":"e0516ae8","chunk-2d0d2bbb":"524a3304","chunk-2d0d32f2":"67fddaca","chunk-2d0d36c5":"e5a62716","chunk-2d0dd643":"3db28637","chunk-2d0dd9ef":"c08cef6f","chunk-2d0de6b7":"55671234","chunk-2d0e24e7":"17c3d377","chunk-2d0e273d":"0814700f","chunk-2d0e5231":"9df63a83","chunk-2d0e8803":"0e5e11ac","chunk-2d0f0499":"2096393e","chunk-2d208c7c":"adae7d8a","chunk-2d20f2e7":"a6eb05a7","chunk-2d20fb76":"9a1462cb","chunk-2d2109de":"07488ab6","chunk-2d217924":"1208e8bc","chunk-2d217b04":"df315181","chunk-2d21a36c":"e69c81c5","chunk-2d21a775":"61aea1f0","chunk-2d21b25b":"b57952ea","chunk-2d21b86e":"9bcb85db","chunk-2d21d0c7":"e37b4693","chunk-2d21db8d":"1cafbe57","chunk-2d21dbb9":"6e62a7c9","chunk-2d21f489":"a4260cc6","chunk-2d2214b5":"3dded18b","chunk-2d22179b":"d84fa29f","chunk-2d225d9a":"e7fb0809","chunk-2d225f87":"67d5bf1a","chunk-2d226c79":"ea12001a","chunk-2d2308cf":"5c039484","chunk-2d2380c1":"72c4f583"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"AccountPage":1,"CatalogPage~OrdersPage~ProductPage~ShoppingCartPage":1,"CatalogPage~ProductPage~ShoppingCartPage":1,"CatalogPage":1,"IndexPage~ShoppingCartPage":1,"ShoppingCartPage":1,"ProductPage":1,"OrdersPage":1,"ContactsPage":1,"IndexPage":1,"PricesPage":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"AccountPage":"AccountPage","CatalogPage~OrdersPage~ProductPage~ShoppingCartPage":"CatalogPage~OrdersPage~ProductPage~ShoppingCartPage","CatalogPage~ProductPage~ShoppingCartPage":"CatalogPage~ProductPage~ShoppingCartPage","CatalogPage":"CatalogPage","IndexPage~ShoppingCartPage":"IndexPage~ShoppingCartPage","ShoppingCartPage":"ShoppingCartPage","ProductPage":"ProductPage","OrdersPage":"OrdersPage","ContactsPage":"ContactsPage","IndexPage":"IndexPage","PricesPage":"PricesPage"}[chunkId]||chunkId) + "." + {"AccountPage":"a6852e53","CatalogPage~OrdersPage~ProductPage~ShoppingCartPage":"11a457f9","CatalogPage~ProductPage~ShoppingCartPage":"b7c279d0","CatalogPage":"389e35a1","IndexPage~ShoppingCartPage":"961c0619","ShoppingCartPage":"c2257763","ProductPage":"8a86e950","OrdersPage":"68753bc4","ContactsPage":"67c3b96e","chunk-fe4a6dc6":"31d6cfe0","IndexPage":"de2a0d64","PricesPage":"172ea40e","chunk-2d0a34e8":"31d6cfe0","chunk-2d0a47fc":"31d6cfe0","chunk-2d0a4b23":"31d6cfe0","chunk-2d0b1db6":"31d6cfe0","chunk-2d0ba187":"31d6cfe0","chunk-2d0bdcab":"31d6cfe0","chunk-2d0be158":"31d6cfe0","chunk-2d0c02b3":"31d6cfe0","chunk-2d0c06e4":"31d6cfe0","chunk-2d0c19d7":"31d6cfe0","chunk-2d0c5777":"31d6cfe0","chunk-2d0c7306":"31d6cfe0","chunk-2d0c8c23":"31d6cfe0","chunk-2d0ccb7b":"31d6cfe0","chunk-2d0cfe76":"31d6cfe0","chunk-2d0d2bbb":"31d6cfe0","chunk-2d0d32f2":"31d6cfe0","chunk-2d0d36c5":"31d6cfe0","chunk-2d0dd643":"31d6cfe0","chunk-2d0dd9ef":"31d6cfe0","chunk-2d0de6b7":"31d6cfe0","chunk-2d0e24e7":"31d6cfe0","chunk-2d0e273d":"31d6cfe0","chunk-2d0e5231":"31d6cfe0","chunk-2d0e8803":"31d6cfe0","chunk-2d0f0499":"31d6cfe0","chunk-2d208c7c":"31d6cfe0","chunk-2d20f2e7":"31d6cfe0","chunk-2d20fb76":"31d6cfe0","chunk-2d2109de":"31d6cfe0","chunk-2d217924":"31d6cfe0","chunk-2d217b04":"31d6cfe0","chunk-2d21a36c":"31d6cfe0","chunk-2d21a775":"31d6cfe0","chunk-2d21b25b":"31d6cfe0","chunk-2d21b86e":"31d6cfe0","chunk-2d21d0c7":"31d6cfe0","chunk-2d21db8d":"31d6cfe0","chunk-2d21dbb9":"31d6cfe0","chunk-2d21f489":"31d6cfe0","chunk-2d2214b5":"31d6cfe0","chunk-2d22179b":"31d6cfe0","chunk-2d225d9a":"31d6cfe0","chunk-2d225f87":"31d6cfe0","chunk-2d226c79":"31d6cfe0","chunk-2d2308cf":"31d6cfe0","chunk-2d2380c1":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
